export const colors = {
  done: 'blue',
  rejected: 'red',
  callRejected: 'red',
};
